import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-plano-de-saude")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-plano-de-saude"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-plano-de-saude"]!.metaDescription,
    path: "/agente-ia-plano-de-saude",
  }),
  component: () => <SegmentRoute slug="agente-ia-plano-de-saude" />,
});
